/* 叫車紀錄頁面>客服資訊 */
export const billHead = [
  '序號',
  '隊編/呼號',
  '接單時間(預計到達)/載到時間',
  '乘客電話/上車地址/備註',
  '進度',
  '派車員/訊息',
  '異常處理',
  '叫車時間',
]

/* 叫車紀錄頁面>訂單詳細資訊modal */
export const detail = [
  '順位',
  '呼號',
  '姓名',
  '司機電話',
  '司機備註',
  '距離(公尺)',
  '目前車輛狀態',
  '是否有搶單',
]

/* 叫車紀錄總查詢>立即單tab */
export const instant = [
  '序號',
  '是否為後派預約',
  '隊編/呼號',
  '叫車時間',
  '進線電話',
  '派車員',
  '種類',
  '上車地址',
  '派車單狀態',
  '是否出現異常',
  '檢視',
]

/* 叫車紀錄總查詢>路招單tab */
export const road = [
  '訂單編號',
  '隊編/呼號',
  '上車地址',
  '下車地址',
  '載客時間',
  '付款時間',
  '付款金額',
]

/* 叫車紀錄總查詢>預約前派tab */
export const reserveBefore = [
  { title: '序號', width: '3%' },
  { title: '預約種類', width: '7%' },
  { title: '司機隊編/呼號', width: '8%' },
  { title: '創立時間', width: '7%' },
  { title: '預約時間', width: '7%' },
  { title: '客服/進線電話', width: '7%' },
  { title: '上車地址', width: '10%' },
  { title: '下車地址', width: '10%' },
  { title: '上車備註', width: '7%' },
  { title: '乘客備註', width: '7%' },
  { title: '目前進度', width: '7%' },
  { title: '應徵司機', width: '5%' },
  { title: '檢視', width: '7%' },
]

/* 叫車紀錄總查詢>預約後派tab */
export const reserveAfter = [
  { title: '序號', width: '4%' },
  { title: '來電時間', width: '10%' },
  { title: '來電電話', width: '10%' },
  { title: '預約時間', width: '10%' },
  { title: '客服人員', width: '10%' },
  { title: '上車地點', width: '14%' },
  { title: '備註', width: '12%' },
  { title: '車輛數', width: '5%' },
  { title: '狀態', width: '15%' },
  { title: '提醒', width: '10%' },
]

export const airportTransfer = [
  { title: '序號', width: '4%' },
  { title: '司機呼號', width: '7%' },
  { title: '預約時間', width: '7%' },
  { title: '乘客姓名電話', width: '7%' },
  { title: '上車地點', width: '7%' },
  { title: '下車地點', width: '7%' },
  { title: '乘客備註', width: '7%' },
  { title: '目前進度', width: '7%' },
  { title: '檢視', width: '7%' },
]

/* 司機資料>入隊司機tab */
export const driver = [
  { title: '隊編/呼號▼', name: 'call_number', width: '100px' },
  { title: '司機姓名', name: 'name', width: '100px' },
  { title: '分隊', name: 'group', width: '' },
  { title: '司機電話', name: 'phone', width: '' },
  { title: '車牌', name: null, width: '' },
  { title: '司機備註', name: null, width: '' },
  { title: '乘客星等', name: null, width: '' },
  { title: '授權', name: 'authorize', width: '' },
]

/* 司機資料>需要提醒審查的司機列表modal */
export const driverAudit = [
  '隊編-姓名',
  '電話',
  '生日',
  '職業駕照發照日',
  '出廠日',
  '職業駕照-種類',
  '執業登記證',
  '驗車',
  '驗錶',
]

/* 預約資料>預約單 */
export const reservation = [
  { title: '序號▼', width: '40px' },
  { title: '預約種類', width: '50px' },
  { title: '司機隊編/呼號', width: '70px' },
  { title: '預約時間▼', width: '160px' },
  { title: '客服/乘客電話', width: '110px' },
  { title: '上車地址', width: '200px' },
  { title: '下車地址', width: '200px' },
  { title: '上車備註', width: '180px' },
  { title: '乘客備註', width: '180px' },
  { title: '一小時提醒', width: '60px' },
  { title: '目前進度', width: '80px' },
  { title: '應徵司機', width: '50px' },
  { title: '檢視', width: '30px' },
]

export const carState = [
  '隊編/呼號',
  '姓名',
  '電話',
  '備註',
  '應徵時間',
  '配對司機',
]

export const lineApp = [
  '序號',
  '預約種類',
  '司機隊編/呼號',
  '預約時間',
  '客服/乘客電話',
  '上車地址',
  '下車地址',
  '上車備註',
  '乘客備註',
  '目前進度',
  '檢視',
]

/* 企業用戶>司機請款單 */
export const withdrawal = [
  '領款單序號',
  '編號-名稱',
  '實際領款日期',
  '幾張電子簽單',
  '實領金額',
  '手續費',
  '簽單金額',
  '刪除',
  '下載',
]

/* 行動支付>孕婦乘車 */
export const pregnantService = [
  '編號',
  '交易日期時間',
  '好孕交易序號',
  '車隊訂單編號',
  '司機隊編/車號',
  '孕婦姓名',
  '原始車資',
  '乘車金點數',
  '孕婦實際支付金額',
  '備註',
]



// WEBPACK FOOTER //
// ./src/constants/tableHead.js